module.exports = __webpack_public_path__ + "media/images/statusPage__503-cb5cd13882216aafaca3b268ae4ea8cc.png";